import scene1Source from "./sample/ch1/scene1.pix?raw";
import scene2Source from "./sample/ch1/scene2.pix?raw";
import manifestJson from "./sample/project.pix.json";
import type { ProjectManifest } from "@pix/shared";

export interface ProjectFiles {
  manifest: ProjectManifest;
  scripts: Record<string, string>;
}

export function makeInitialProject(): ProjectFiles {
  return {
    manifest: manifestJson as ProjectManifest,
    scripts: {
      "ch1/scene1.pix": scene1Source,
      "ch1/scene2.pix": scene2Source,
    },
  };
}
